module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_06@2x-a957bb7d2d6d071009ab901c67df9f2a.jpg";